/** Month labels for chart x-axis. */
const CHART_LABELS = ["Jan", "Fév", "Mar", "Avr", "Mai", "Juin", "Juil", "Août", "Sep", "Oct", "Nov", "Déc"];

/** Solid stroke colors for currency series, indexed by position. */
const CURRENCY_COLORS = ["#4CAF50", "#2196F3", "#FFC107", "#9C27B0", "#FF5722"];

/** Data type constants for toggling between chart views. */
const DATA_TYPES = {
    RESERVATIONS: 'reservations',
    CONTACTS: 'contacts',
    TOTAL: 'total'
};

/**
 * Extracts monthly values for the selected currency and type.
 * @param {Object} incomeData - Income data from the API
 * @param {string} currency - Selected currency code
 * @param {string} type - Data type key
 * @returns {Array<number>} Array of 12 monthly values
 */
function getChartValues(incomeData, currency, type) {
    if (type === DATA_TYPES.TOTAL) {
        const reservations = incomeData.data.reservations[currency] || Array(12).fill(0);
        const contacts = incomeData.data.contacts[currency] || Array(12).fill(0);
        return reservations.map((val, idx) => val + contacts[idx]);
    }
    return incomeData.data[type][currency] || Array(12).fill(0);
}

/**
 * Builds a single line series (values + stroke color) for the SVG chart.
 * @param {Object|null} incomeData - Income data from the API
 * @param {string} selectedCurrency - Selected currency code
 * @param {string} selectedType - Selected data type (reservations/contacts/total)
 * @returns {{values: Array<number>, color: string}} Series values and stroke color
 */
function buildSeries(incomeData, selectedCurrency, selectedType) {
    if (!incomeData || !selectedCurrency) {
        return { values: Array(12).fill(0), color: CURRENCY_COLORS[0] };
    }
    const idx = incomeData.currencies.indexOf(selectedCurrency);
    const color = CURRENCY_COLORS[(idx < 0 ? 0 : idx) % CURRENCY_COLORS.length];
    return { values: getChartValues(incomeData, selectedCurrency, selectedType), color };
}

export { CHART_LABELS, CURRENCY_COLORS, DATA_TYPES, buildSeries };
